import React                            from 'react';
import { Box, TextField, IconButton }   from '@mui/material';
import SendIcon                         from '@mui/icons-material/Send';
import { useTranslation }               from 'react-i18next';


const MessageInput = ({ value, onChange, onSend }) => {
    const { t } = useTranslation();
    return (
        <Box sx={{ display: 'flex', padding: 2, borderTop: '1px solid #e0e0e0', backgroundColor: '#f5f5f5' }}>
            <TextField
                fullWidth
                variant="outlined"
                placeholder={t("Scrivi un messaggio..")}
                value={value}
                onChange={onChange}
                onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                        e.preventDefault();
                        onSend();
                    }
                }}
                multiline
                maxRows={4} 
                sx={{ 
                    marginRight: 2, 
                    bgcolor: 'white', 
                    overflowY: 'auto',
                    '& .MuiOutlinedInput-root': {
                        '&:hover fieldset': {
                            borderColor: '#25375d',
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: '#25375d',
                        },
                    },
                }}
            />
            <IconButton color="primary" onClick={onSend}>
                <SendIcon sx={{ color: '#25375d'}} />
            </IconButton>
        </Box>
    );
};

export default MessageInput;
